'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import zurl from 'zurl';

export const qs_o = ()=>zurl.qs_parse(location.search.substr(1), {safe: true});
